import {Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {IWithPermissionModel} from '../../../common/permission/api/entity/iWithPermission.model';
import {PermissionService} from "../../../common/permission/api/service/permission.service";

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: [
      './button.component.scss'
  ]
})
export class ButtonComponent implements OnChanges {
  @Input() badge: number;
  @Input() size: string;
  @Input() label: string;
  @Input() iconName: string;
  @Input() iconHeight = 16;
  @Input() fill : 'clear' | 'solid' = 'clear' ;
  @Input() disabled = false;
  _disabled = false;
  disabledAccordingToPermission = false;
  @Input() loading = false;
  @Input() entity: IWithPermissionModel;
  @Input() permission: string;
  @Input() tooltip: string = undefined;
  @Input() hideIfNoPermission = true;
  @Input() fullWidth = false;
  @Output() clickEvent: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  classNames: string;
  display = true;
  hide = false;

  // Not used anymore
  @Input() withPadding = true;
  @Input() withMargin = true;
  @Input() color: 'primary' | 'accent' | 'warn' | 'white' = 'accent';

  constructor(private permissionService: PermissionService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.classNames = '';
   /*  if (this.withMargin === false) {
      this.classNames += ' ion-no-margin';
    }
    if (this.withPadding === false) {
      this.classNames += ' ion-no-padding';
    }**/

    this._disabled = this.disabled;
    if (changes['entity'] || changes['permission']) {
      this.disabledAccordingToPermission = false;
      this.hide = false;
      if (this.permission) {
        let hasEntity = false;
        if (this.entity) {
          hasEntity = this.entity.permissions?.permissions?.indexOf(this.permission) > -1;
        }
        if (!hasEntity) {
          this.disableAccordingToPermission();
        }
      }
    }
  }

  disableAccordingToPermission() {
    this._disabled = true;
    this.disabledAccordingToPermission = true;
    this.hide = this.hideIfNoPermission;
  }

  click(mouseEvent: MouseEvent) {
    if (!this._disabled) {
      this.clickEvent?.emit(mouseEvent);
    }
  }
}
